module.exports = __webpack_public_path__ + "img/user.requesting.service.2.ce1a8549.jpg";